export default "__VITE_ASSET__a913d323__"